import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineCountryDegreeType extends TitleBase {
	private countryValue: string;
	private disciplineValue: string;
	private degreeTypeValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);

		return (
			this.indexableFilters.length >= 3 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE)
		);
	}

	protected getPageTitle(): string {
		return `${this.degreeTypeValue} in ${this.disciplineValue} in ${this.countryValue}`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		return `${this.totalSearchResults} ${degreeTypeValue} in ${this.disciplineValue} in ${this.countryValue} | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.degreeTypeValue} in the field of ${this.disciplineValue}`, ` in ${this.countryValue}`);
	}
}
